__turbopack_context__.v({
  "newsletter-subscribe-form": "woBWaq_newsletter-subscribe-form",
  "newsletter-subscribe-form__action": "woBWaq_newsletter-subscribe-form__action",
  "newsletter-subscribe-form__consent": "woBWaq_newsletter-subscribe-form__consent",
  "newsletter-subscribe-form__container": "woBWaq_newsletter-subscribe-form__container",
  "newsletter-subscribe-form__form": "woBWaq_newsletter-subscribe-form__form",
  "newsletter-subscribe-form__input-area": "woBWaq_newsletter-subscribe-form__input-area",
});
